import { render, staticRenderFns } from "./HomeServices.vue?vue&type=template&id=2df15c24"
import script from "./HomeServices.vue?vue&type=script&lang=js"
export * from "./HomeServices.vue?vue&type=script&lang=js"
import style0 from "./HomeServices.vue?vue&type=style&index=0&id=2df15c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports